module.exports = require("react-native-version-number");